module.exports = __webpack_public_path__ + "static/img/reset.0ba9e373.svg";